parseTokenPlainTime